import React from 'react';
import { useNavigate } from 'react-router-dom';

function Card({ type, title, description, slug, article }) {
  const navigate = useNavigate();

  const getThumbnail = () => {
    if (article?.image_thumb) return article.image_thumb;
    if (article?.article_content) {
      const imgMatch = article.article_content.match(/<img[^>]+src="([^">]+)"/);
      if (imgMatch) {
        const filename = imgMatch[1].split('/').pop();
        return `https://d1vkr02c9udppg.cloudfront.net/${filename}`;
      }
    }
    return "/default-thumb.jpg";
  };

  const handleClick = () => {
    if (slug) {
      navigate(`/${type === 'igtt' ? 'video' : 'article'}/${slug}`, {
        state: { article }
      });
    }
  };

  return (
    <div className="card border rounded-lg shadow-md p-4">
      <div className="card-image bg-gray-200 h-40 mb-4">
        <img
          src={getThumbnail()}
          alt={title}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="card-content">
        <p className="card-type text-sm text-gray-500 mb-2">
          {type === 'igtt' ? 'Video' : 'Article'}
        </p>
        <h3 className="card-title text-lg font-bold mb-2">{title}</h3>
        <p className="card-description text-sm text-gray-700">{description}</p>
        <button 
          onClick={handleClick}
          className="more-link text-blue-500 hover:underline mt-2 block border-none bg-transparent cursor-pointer p-0 text-left"
        >
          More...
        </button>
      </div>
    </div>
  );
}

export default Card;